const Urls = {
  //AUTH
  ACCOUNT_LOGIN: 'auth/login',
  ACCOUNT_REGISTER: 'auth/register',
  ACCOUNT_RESET_SEND_MAIL: 'auth/resetPassword',
  ACCOUNT_RESET_UPDATE_PASSWORD: 'auth/updatePassword',
  ACCOUNT_CHANGE_PASSWORD: 'auth/changePassword',
  ACCOUNT_VERIFY_RESET_TOKEN: 'auth/validateToken',
  ACCOUNT_REFRESH_TOKEN: 'auth/refreshToken',
  ACCOUNT_UNSUBSCRIBE_VERIFY_TOKEN: 'auth/validateUnsubscribe',
  ACCOUNT_VERIFY_EMAIL: 'auth/verifyEmail',
  ACCOUNT_UNSUBSCRIBE_USER: 'auth/unsubscribe',

  SPONSOR_ATTENDEES_GET_ALL: `eventRegistration/showByUser/#{attendeeId}`,
  SPONSOR_ATTENDEES_ADD: `eventRegistration/sponsorship/asset`,
  SPONSOR_UPDATE: `eventRegistration/sponsorship/asset/#{sponsorId}`,
  SPONSOR_ATTENDEES_DELETE: `eventRegistration/sponsorship/asset/#{attendeeId}`,
  SPONSOR_REMOVE_FROM_CART: `eventRegistration/sponsorship/cart/#{eventId}`,
  SPONSOR_ATTENDEES_UPDATE: `eventRegistration/#{attendeeId}`,

  //USERS
  USER_GET_ALL_USERS: 'users',
  USER_ADD: 'users',
  USER_DELETE_USER: 'users/#{userId}',
  USER_UPDATE_USER_PROFILE: 'users/#{userId}',
  USER_FETCH_BY_ID: 'users/#{userId}',
  USER_UPDATE_BY_ID: 'users',
  USER_UPDATE_BY_ADMIN_ID: 'users/#{userId}',
  USER_DELETE_BY_ID: 'users/#{userId}',
  USER_DETAILS_BY_ID: 'users/details',
  USER_UPDATE_STATUS_BY_ID: 'users/#{userId}/#{userStatus}',
  USER_UPDATE_WILL_RECEIVE_BY_ID: 'users/#{userId}/will-receive-update',
  USER_UPDATE_TERMS_BY_ID: 'users/terms/#{userId}',

  //CHAPTERS
  CHAPTER_GET_ALL: 'chapters',
  CHAPTER_ADD: 'chapters',
  CHAPTER_FETCH_BY_ID: 'chapters/#{chapterId}',
  CHAPTER_UPDATE_BY_ID: 'chapters/#{chapterId}',
  CHAPTER_DELETE_BY_ID: 'chapters/#{chapterId}',
  CHAPTER_SEQUENCE: 'chapters/sequence',

  //KEYWORDS
  KEYWORD_GET_ALL: 'keywords',
  KEYWORD_ADD: 'keywords',
  KEYWORD_FETCH_BY_ID: 'keywords/#{keywordId}',
  KEYWORD_UPDATE_BY_ID: 'keywords/#{keywordId}',
  KEYWORD_DELETE_BY_ID: 'keywords/#{keywordId}',

  //ADS
  AD_GET_ALL: 'campaigns',
  AD_ADD: 'campaigns',
  ADS_GET_ALL_APPROVED: 'campaigns/approved',
  ADS_GET_ALL_ACCOUNTS: 'campaigns/account',
  AD_FETCH_BY_ID: 'campaigns/#{adsId}',
  AD_UPDATE_BY_ID: 'campaigns/#{adsId}',
  AD_UPDATE_STATUS_BY_ID: 'campaigns/#{adsId}/#{adsStatus}',
  AD_DELETE_BY_ID: 'campaigns/#{adsId}',
  ADS_GET_BY_USERID: 'campaigns/userId/#{userId}',
  ADS_POST_PAYMENT: 'campaigns/adPayment',
  ADS_POST_PAYMENT_SUCCESS: 'campaigns/adPaymentConfirm',

  //EVENT TEMPLATES SCHEDULER

  EVENT_TEMPLATE_SCHEDULER_GET_ALL: 'eventEmailTemplate',
  ALL_EMAIL_SCHEDULERS: 'eventEmailTemplate',
  EVENT_TEMPLATE_SCHEDULER_ADD: 'eventEmailTemplate',
  EVENT_TEMPLATE_SCHEDULER_FETCH_BY_EVENT_ID:
    'eventEmailTemplate/event/#{eventEmailTemplateId}',
  EVENT_TEMPLATE_SCHEDULER_FETCH_BY_ID:
    'eventEmailTemplate/#{eventEmailTemplateId}',
  ALL_SCHEDULED_DATES: 'eventEmailTemplate/schedule-dates',
  EVENT_TEMPLATE_SCHEDULER_UPDATE_BY_ID:
    'eventEmailTemplate/#{eventTemplateSchedulerId}',
  // EVENT_TEMPLATE_SCHEDULER_UPDATE_STATUS_BY_ID: 'eventtemplatescheduler/#{eventTemplateSchedulerId}/#{eventTemplateSchedulerStatus}',
  EVENT_TEMPLATE_SCHEDULER_DELETE_BY_ID:
    'eventEmailTemplate/#{eventTemplateSchedulerId}',
  EVENT_TEMPLATE_SCHEDULERS_GET_BY_USERID:
    'eventEmailTemplate/userId/#{userId}',
  EVENT_TEMPLATE_SCHEDULER_SEND_DIRECT_EMAIL_BY_ID:
    'eventEmailTemplate/sendDirectEmail/#{eventTemplateSchedulerId}',
  EVENT_TEMPLATE_SCHEDULER_PREVIEW:
    'eventEmailTemplate/preview/#{eventId}/#{schedulerId}',

  //EMAILCODE
  EMAILCODE_GET_ALL: 'emailCodes',
  EMAILCODE_ADD: 'emailCodes',
  EMAILCODE_FETCH_BY_ID: 'emailCodes/#{emailCodeId}',
  EMAILCODE_UPDATE_BY_ID: 'emailCodes/#{emailCodeId}',
  EMAILCODE_DELETE_BY_ID: 'emailCodes/#{emailCodeId}',

  //EVENT TYPES
  EVENTTYPES_GET_ALL: 'eventTypes',
  EVENTTYPES_ADD: 'eventTypes',
  EVENTTYPES_FETCH_BY_ID: 'eventTypes/#{eventTypesId}',
  EVENTTYPES_UPDATE_BY_ID: 'eventTypes/#{eventTypesId}',
  EVENTTYPES_DELETE_BY_ID: 'eventTypes/#{eventTypesId}',

  //SPONSORS

  SPONSOR_GET_ALL: 'sponsors',
  SPONSOR_ADD: 'sponsors',
  SPONSOR_FETCH_BY_ID: 'sponsors/#{sponsorsId}',
  SPONSOR_UPDATE_BY_ID: 'sponsors/#{sponsorsId}',
  SPONSOR_DELETE_BY_ID: 'sponsors/#{sponsorsId}',
  SPONSOR_VENDOR_REPS_BY_REGISTRATION:
    'sponsors/registrations/#{registrationId}/vendor-reps',

  //JOBFEES
  JOBFEES_GET_ALL: 'jobFees',
  JOBFEES_ADD: 'jobFees',
  JOBFEES_GET_BY_ID: 'jobFees/#{jobFeesId}',
  JOBFEES_UPDATE_BY_ID: 'jobFees/#{jobFeesId}',
  JOBFEES_DELETE_BY_ID: 'jobFees/#{jobFeesId}',

  //ADFEES
  ADFEES_GET_ALL: 'adFees',
  ADFEES_ADD: 'adFees',
  ADFEES_GET_BY_ID: 'adFees/#{adFeesId}',
  ADFEES_UPDATE_BY_ID: 'adFees/#{adFeesId}',
  ADFEES_DELETE_BY_ID: 'adFees/#{adFeesId}',

  //committeeMember
  COMMITTEE_MEMBERS_GET_ALL: 'committeeMembers',
  COMMITTEE_MEMBERS_ADD: 'committeeMembers',
  COMMITTEE_MEMBERS_GET_BY_ID: 'committeeMembers/#{committeeMemberId}',
  COMMITTEE_MEMBERS_UPDATE_BY_ID: 'committeeMembers/#{committeeMemberId}',
  COMMITTEE_MEMBERS_DELETE_BY_ID: 'committeeMembers/#{committeeMemberId}',
  COMMITTEE_MEMBERS_SEQUENCE: 'committeeMembers/sequence',

  //JOBS
  JOBS_GET_ALL: 'jobs',
  JOBS_GET_ALL_APPROVED: 'jobs/approved',
  JOBS_ADD: 'jobs',
  JOBS_GET_BY_ID: 'jobs/#{jobsId}',
  JOBS_UPDATE_BY_ID: 'jobs/#{jobsId}',
  JOBS_DELETE_BY_ID: 'jobs/#{jobsId}',
  JOBS_UPDATE_STATUS_BY_ID: 'jobs/#{jobsId}/#{jobStatus}',
  JOBS_GET_BY_USERID: 'jobs/userId/#{userId}',
  JOBS_GET_ALL_ACCOUNTS: 'jobs/account',
  JOBS_POST_PAYMENT: 'jobs/jobPayment',
  JOBS_POST_PAYMENT_SUCCESS: '/jobs/jobPaymentConfirm',

  //SPEAKERS
  SPEAKERS_GET_ALL: 'speakers',
  SPEAKERS_ADD: 'speakers',
  SPEAKERS_GET_BY_ID: 'speakers/#{speakersId}',
  SPEAKERS_UPDATE_BY_ID: 'speakers/#{speakersId}',
  SPEAKERS_DELETE_BY_ID: 'speakers/#{speakersId}',

  //COMPANIES
  COMPANIES_GET_ALL: 'companies',
  COMPANIES_ADD: 'companies',
  COMPANIES_GET_BY_ID: 'companies/#{companiesId}',
  COMPANIES_UPDATE_BY_ID: 'companies/#{companiesId}',
  COMPANIES_DELETE_BY_ID: 'companies/#{companiesId}',

  //COUPONCODES
  COUPONCODES_GET_ALL: 'couponCodes',
  COUPONCODES_ADD: 'couponCodes',
  COUPONCODES_GET_BY_ID: 'couponCodes/#{couponCodesId}',
  COUPONCODES_UPDATE_BY_ID: 'couponCodes/#{couponCodesId}',
  COUPONCODES_DELETE_BY_ID: 'couponCodes/#{couponCodesId}',
  COUPONCODES_USERS_TRACKS: 'couponCodes/users/#{couponCodesId}',

  //EVENTOPTIONGROUPS
  EVENTOPTIONGROUPS_GET_ALL: 'eventOptionGroups',
  EVENTOPTIONGROUPS_ADD: 'eventOptionGroups',
  EVENTOPTIONGROUPS_GET_BY_ID: 'eventOptionGroups/#{eventOptionGroupsId}',
  EVENTOPTIONGROUPS_UPDATE_BY_ID: 'eventOptionGroups/#{eventOptionGroupsId}',
  EVENTOPTIONGROUPS_DELETE_BY_ID: 'eventOptionGroups/#{eventOptionGroupsId}',

  //EVENTOPTIONS
  EVENTOPTIONS_GET_ALL: 'eventOptions',
  EVENTOPTIONS_ADD: 'eventOptions',
  EVENTOPTIONS_SEQUENCE: 'eventOptions/sequence',
  EVENTOPTIONS_GET_BY_ID: 'eventOptions/#{eventOptionsId}',
  EVENTOPTIONS_UPDATE_BY_ID: 'eventOptions/#{eventOptionsId}',
  EVENTOPTIONS_DELETE_BY_ID: 'eventOptions/#{eventOptionsId}',
  EVENTOPTIONS_GET_BY_EVENTID: 'eventOptions/event/#{eventId}',
  EVENTOPTIONS_ADMIN_GET_BY_EVENTID: 'eventOptions/list/#{eventId}',

  //EVENTS
  EVENTS_GET_ALL: 'events',
  PAST_EVENTS_GET_ALL: 'events/pastEvents',
  EVENTS_USER_GET_ALL: 'events/chapter',
  EVENTS_USER_GET_ALL_COMMITTEE_MEMBERS: 'committeeMembers',
  EVENTS_GET_BY_CHAPTERS: 'events/chapter',
  EVENTS_ADD: 'events',
  EVENTS_GET_BY_ID: 'events/#{eventsId}',
  EVENTS_UPDATE_BY_ID: 'events/#{eventsId}',
  EVENTS_DELETE_BY_ID: 'events/#{eventsId}',
  EVENTS_DUPLICATE_BY_ID: 'events/duplicate/#{eventsId}',
  EVENTS_UPDATE_STATUS_BY_ID: 'events/#{eventsId}/#{eventsStatus}',
  EVENTS_UPDATE_REFUND_STATUS_BY_ID: 'eventRegistration/refund',
  EVENTS_CANCEL_REFUND: 'eventRegistration/cancelRefund',

  //EVENT REGISTERED
  GET_ALL_SPONSORS_LOGOS: 'eventRegistration/sponsor',
  GET_ALL_REGISTRATION: 'eventRegistration',
  GET_REGISTRATIONS_BY_EVENTID: 'eventRegistration/event',
  UPDATE_REGISTRATIONS_OPTIONS_BY_EVENTID: 'eventRegistration/editOption',
  CANCEL_GROUP_OF_EVENT_REGISTRATIONS_BY_EVENTID:
    'eventRegistration/cancelEventRegistration',
  ADD_ATTENDEE: 'eventRegistration',
  GET_ALL_ATTENDEE: 'eventRegistration/showByUser/#{eventId}/#{attendeeType}',
  SPONSORSHIP_REPS:
    'eventRegistration/sponsorship/#{sponsorRegistrationId}/reps',
  GET_ALL_ATTENDEE_TRANSACTION_ID: 'eventRegistration/#{transactionId}',
  DELETE_ATTENDEE: 'eventRegistration/#{eventRegistrationId}',
  ADMIN_DELETE_TO_BE_PAID_REGISTRATION:
    'eventRegistration/admin/#{eventRegistrationId}',
  UPDATE_ATTENDEE: 'eventRegistration/#{eventRegistrationId}',
  COUPONCODES_VERIFY: 'eventRegistration/verifyCoupon/#{couponCode}/#{eventId}',
  COUPONCODES_APPLY: 'eventRegistration/applyCoupon',
  PAYMENT_UPDATE_BY_EVENT_ID: `eventRegistration/payment/#{eventId}/sponsor`,
  PAYMENT_UPDATE_NORMAL_REGISTRATION_BY_EVENT_ID: `eventRegistration/payment/#{eventId}/normal`,
  EVENTS_GET_ALL_MYEVENTS: 'eventRegistration/myEvents',
  EVENT_POST_PAYMENT_SUCCESS: 'eventRegistration/paymentConfirmation',
  ADD_NOTE_BY_EVENT_REGISTRATION: 'eventRegistration/addNote',
  GET_ALL_WAITING_LIST: 'eventRegistration/waitingList',
  GET_ALL_USERS_WAITING_LIST: 'eventRegistration/waitingList',
  //REGISTRATION HISTORY / RECEIPTS / CREDIT HISTORY
  REGISTRATION_HISTORY_GET_ALL: 'eventRegistration/history',
  USER_REGISTRATIONS: 'users/#{userId}/registrations',
  USER_CREDIT_HISTORY: 'users/#{userId}/credit-history',
  USER_UPDATE_CREDIT: 'users/#{userId}/credit',
  MOVE_WAITING_LIST_TO_REGISTRATION:
    'eventRegistration/waitingList/#{waitingListId}/moveToRegistration',
  CANCEL_WAITING_LIST_ENTRY:
    'eventRegistration/waitingList/#{waitingListId}/cancel',
  //EVENT REFUND
  GET_REFUND_BY_EVENTID: 'eventRegistration/refund/event/#{eventId}',
  GET_REFUND_BY_ALL_EVENTS: 'eventRegistration/refund/events',
  UPDATE_REFUND_STATUS: 'eventRefund/#{eventStatus}',

  // EMAIL TO MEMBERS
  EMAIL_TO_MEMBERS: 'emails',

  //TEMPLATE PHOTOS
  TEMPLATE_PHOTOS_GET: 'templatePhotos',
  TEMPLATE_PHOTOS_POST: 'templatePhotos',

  // SPECIAL PAYMENT
  SPECIAL_PAYMENT: '/specialPayment',
  SPECIAL_PAYMENT_SECRET: '/specialPayment/secret',
  SPECIAL_PAYMENT_SUCCESS: 'specialPayment/confirm',

  //CONTACT US FORM
  CONTACT_US: '/emails/contact',

  //STEM
  STEM_GET: 'stem',
  STEM_UPDATE_BY_ID: 'stem/#{stemId}',

  // INDUSTRY
  INDUSTRY_GET: 'industry',
  INDUSTRY_ADD: 'industry',
  INDUSTRY_UPDATE_BY_ID: 'industry/#{industryId}',

  // CAREER MENTORSHIP
  CAREER_MENTORSHIP_GET: 'careerMentorship',
  CAREER_MENTORSHIP_UPDATE_BY_ID: 'careerMentorship/#{careerMentorshipId}',

  // PBSS International
  PBSS_INTERNATIONAL_GET: 'pbssInternational',
  PBSS_INTERNATIONAL_UPDATE_BY_ID: 'pbssInternational/#{pbssInternationalId}',

  // PBSS Files (admin file manager)
  PBSS_FILES_GET: 'pbssFiles',
  PBSS_FILES_ADD: 'pbssFiles',
  PBSS_FILES_DELETE: 'pbssFiles/#{fileId}',

  // HISTORY
  HISTORY_GET_LATEST: 'history',
};
export default Urls;
